import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface VoiceRecordingsFilterProps {
  filterIndex: number;
}

/**
 * Renders radio buttons for filtering sessions by voice recording availability
 */
export const VoiceRecordingsFilter = ({ filterIndex }: VoiceRecordingsFilterProps) => {
  const { t } = useTranslation();
  const { getValues, control } = useFormContext();

  const { update } = useFieldArray({ control, name: 'filters' });

  const hasRecording = useWatch({ control, name: `filters.${filterIndex}.hasRecording` });

  const handleChange = (value: string) => {
    let booleanValue: boolean | null;
    if (value === 'true') {
      booleanValue = true;
    } else if (value === 'false') {
      booleanValue = false;
    } else {
      booleanValue = null;
    }
    const currentFilter = getValues(`filters.${filterIndex}`);
    update(filterIndex, { ...currentFilter, hasRecording: booleanValue });
  };

  return (
    <div className="space-y-3">
      <RadioGroup
        value={hasRecording?.toString() || ''}
        onValueChange={handleChange}
        className="gap-0"
      >
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="true" id={`recording-true-${filterIndex}`} />
          <Label htmlFor={`recording-true-${filterIndex}`} className="cursor-pointer font-normal">
            {t('brain_logs.filters.voice_recordings.has_recordings')}
          </Label>
        </div>
        <div className="flex items-center space-x-2 rounded-sm px-2 py-1.5 hover:bg-selected-soft">
          <RadioGroupItem value="false" id={`recording-false-${filterIndex}`} />
          <Label htmlFor={`recording-false-${filterIndex}`} className="cursor-pointer font-normal">
            {t('brain_logs.filters.voice_recordings.no_recordings')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
